import { Aspect } from '@teambit/harmony';

export const ApplicationAspect = Aspect.create({
  id: 'teambit.harmony/application',
});
